export const DUPLICATE_ERROR_CODE = 'DUPLICATE_ERROR'
export const ACCOUNT_THERMOSTAT_ALREADY_REGISTERED_CODE =
	'account_thermostat_already_registered'
export const INVALID_THERMOSTAT_CODE = 3
export const SUCCESSFUL_RESPONSE_CODE = 0
export const EXCEEDED_LIMIT_ERROR_CODE = 'seat_limit_exceeded'
